/**
 * The four Stack layers, as one compact band directly under the hero.
 * Replaces the old HomieAndStack + StackSpotlight sections on the homepage.
 */
import { Link } from "@/lib/router-compat";

const LAYERS = [
  { n: 1, label: "Federal grants" },
  { n: 2, label: "State programs" },
  { n: 3, label: "County relief" },
  { n: 4, label: "Employer match" },
];

const StackLayersRow = () => {
  return (
    <section id="homie-and-stack" className="border-y border-border bg-secondary/40">
      <div className="container mx-auto max-w-5xl px-4 py-7">
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 md:gap-x-16">
          {LAYERS.map((l) => (
            <div key={l.n} className="flex items-center gap-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
                {l.n}
              </span>
              <span className="whitespace-nowrap text-xs font-semibold uppercase tracking-tight text-foreground">
                {l.label}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-5 text-center text-sm text-muted-foreground">
          Stack waterfalls through all four layers and adds up everything that's
          actually combinable in your ZIP.{" "}
          <Link to="/stack" className="text-accent underline hover:no-underline">
            How Stack works
          </Link>
        </p>
      </div>
    </section>
  );
};

export default StackLayersRow;
